var map = {
	"./gallery_01.png": 400,
	"./gallery_010.png": 974,
	"./gallery_011.png": 975,
	"./gallery_012.png": 976,
	"./gallery_02.png": 977,
	"./gallery_03.png": 978,
	"./gallery_04.png": 979,
	"./gallery_05.png": 980,
	"./gallery_06.png": 981,
	"./gallery_07.png": 982,
	"./gallery_08.png": 983,
	"./gallery_09.png": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;